const ActionTypes = {
  siteConfiguration: "SITE_CONFIG",
  changePageTitle: "CHANGE_PAGE_TITLE",
  changeDes: "CHANGE_DES",
  changeSiteLanguage: "CHANGE_SITE_LANGUAGE",
  changeHeaderFooterShow: "CHANGE_HEADER_FOOTER_SHOW",
  changeFooterShow: "CHANGE_FOOTER_SHOW",
  toggleLoginAlert: "TOGGLE_LOGIN_ALERT",
};
export default ActionTypes;
